window.car360Overlay = function car360Overlay() {

    var car_overlay = $('.js_carSpinner'),
        car_spinner = $('.js_spinnerWrap'),
        close_button = $('.js_customCloseButton'),
        body = $('body'),
        vehicle_spin_iframe_url;

        if($('.mtcOverlay').length) {
            $('.mtcOverlay').mtcOverlay();
        }

        $.ajax({
            type: 'get',
            url: car_overlay.data('spin-url'),
            crossDomain: true,
            dataType: 'json',
            success: function (response) {
                switch(response.status) {
                    case 'error':
                        console.warn('The spin API failed: ' + response.err_msg);
                        break;
                    case 'spin not found':
                        console.warn('The API did not find a matching spin for this VRM.');
                        break;
                    default:
                        vehicle_spin_iframe_url = response.vehicle.url;
                        $('.js_load360Spinner').show();
                }
            },
            error: function (error) {
                console.warn('The spin API failed to load: ' + error.responseText);
            }
        });

    $(document).on('click', '.js_load360Spinner', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($('#vehicleSpinIframe').length < 1) {
            $('<iframe>', {
                src: vehicle_spin_iframe_url,
                id:  'vehicleSpinIframe',
                frameborder: 0
            }).appendTo(car_spinner);
        }

        car_overlay.addClass('open');

        body.addClass('customOverlayOpen');
    });

    // allow users to click on overlay while open
    car_spinner.on('click', function (e) {
        e.stopPropagation();
    });

    // close overlay when user clicks outside of it
    $(document).on('click', function () {
        car_overlay.removeClass('open');
        body.removeClass('customOverlayOpen');
    });

    // handle close button click
    close_button.on('click', function (e) {
        e.preventDefault();

        car_overlay.removeClass('open');
        body.removeClass('customOverlayOpen');
    });
}

$(window).load(function () {
    car360Overlay();
});